import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { Breadcrumbs } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

import {
  BreadcrumbContainer,
  BreadcrumbLinkComponent,
} from 'app/components/StyledComponents';

type BreadcrumbsComponentProps = {
  breadcrumbsList;
  state?;
};

export const BreadcrumbsComponent = ({
  breadcrumbsList,
  state,
}: BreadcrumbsComponentProps) => {
  const history = useHistory();

  const handleClick = (breadcrumb, breadcrumbIndex) => {
    try {
      if (breadcrumb.isActive) {
        return;
      } else {
        const list = breadcrumbsList.filter(
          (item, index) => index <= breadcrumbIndex,
        );
        list[list.length - 1] = { ...list[list.length - 1], isActive: true };
        history.push(breadcrumb.link, { breadcrumbsList: list });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <BreadcrumbContainer>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {breadcrumbsList?.map((item, index) => (
          <BreadcrumbLinkComponent
            underline={item.isActive ? 'none' : 'always'}
            color={item.isActive ? 'text.primary' : 'inherit'}
            onClick={() => handleClick(item, index)}
            sx={{ cursor: item.isActive ? '' : 'pointer' }}
          >
            {item.label}
          </BreadcrumbLinkComponent>
        ))}
      </Breadcrumbs>
    </BreadcrumbContainer>
  );
};
